import styled from '@emotion/styled';
import { ExamFormat, RoomReserved } from 'api/planning';
import { Icon } from 'semantic-ui-react';

type Props = {
  reservations: RoomReserved[];
};

export const ExistingSessionsInfo = ({ reservations }: Props) => {
  const times = reservations.map((r, id) => {
    const { product, examFormat, component } = getClashedExamDetails(r);

    return (
      <S.Reservation key={`reservation-${id}`}>
        <S.Time>
          {' '}
          <Icon name="clock outline" size="large" />
          <span>
            {r.startTime} - {r.endTime}
          </span>
        </S.Time>
        {info('Product', product)}
        {info('Format', examFormat)}
        {info('Component', component)}
      </S.Reservation>
    );
  });

  return (
    <S.Wrapper data-testid="clashing-sessions">
      <S.Title>Existing sessions</S.Title>
      {times}
    </S.Wrapper>
  );
};

const mapFormat = (format: ExamFormat) => {
  switch (format) {
    case ExamFormat.CD:
      return 'On computer';
    case ExamFormat.PB:
      return 'On paper';
  }
};

const info = (property: string, value: string) => {
  return (
    <div>
      {property}: <S.Value>{value}</S.Value>
    </div>
  );
};

const getClashedExamDetails = (clash: RoomReserved) => {
  if (!clash.isIeltsExam) {
    return {
      product: 'Not IELTS',
      examFormat: '-',
      component: '-',
    };
  }

  return {
    product: clash.productName ?? '-',
    examFormat: clash.examFormat ? mapFormat(clash.examFormat) : '-',
    component: clash.componentName ?? '-',
  };
};

const S = {
  Wrapper: styled.div`
    width: 200px;
  `,
  Title: styled.div`
    margin: 0, auto;
    font-weight: 700;
    font-size: 12px;
    color: orange;
    width: 180px;
    display: block;
    padding-bottom: 5px;
  `,
  Time: styled.div`
    font-weight: 700;
  `,
  Value: styled.span`
    font-weight: 700;
  `,
  Reservation: styled.div`
    border-top: 1px solid #e2e2e3;
    font-size: 12px;
    padding-top: 10px;
    padding-bottom: 10px;
  `,
};
